/* Floral Studio — the enquiry form's one question.

   Every "enquire" link on the site lands on this form, so it asks why
   first and shows only the fields that follow from the answer.

   Anything with `data-fs-for="custom wedding"` belongs to those types;
   no attribute means always shown. Hidden groups have their controls
   DISABLED, not just hidden — a hidden-but-enabled required field blocks
   submission with a validation message the visitor cannot see, which is
   the classic way this pattern breaks.

   Fields marked `data-fs-required` are required only while visible.

   Progressive enhancement: with no JS every group is visible and the
   `data-fs-required` fields are not required, so the form still submits
   and the studio still gets the answer — the radio itself posts as
   `contact[Enquiry]`. */
(function () {
  var TYPES = ['custom', 'wedding', 'subscription', 'other'];

  /* Multi-select groups. Shopify's contact form has no concept of a
     multi-value field — several inputs sharing a name arrive as one
     arbitrary value — so the checkboxes hand their names over to a single
     hidden field carrying a joined string. With no JS the boxes keep their
     names and still post something. */
  function initMulti(scope) {
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-fs-multi]'),
      function (group) {
        if (group.dataset.fsMultiWired === '1') return;
        var target = document.getElementById(group.getAttribute('data-fs-target'));
        if (!target) return;
        group.dataset.fsMultiWired = '1';

        var boxes = Array.prototype.slice.call(
          group.querySelectorAll('input[type="checkbox"]')
        );

        target.disabled = false;
        boxes.forEach(function (b) { b.removeAttribute('name'); });

        function sync() {
          target.value = boxes
            .filter(function (b) { return b.checked; })
            .map(function (b) { return b.value; })
            .join(', ');
        }

        boxes.forEach(function (b) { b.addEventListener('change', sync); });
        sync();
      }
    );
  }

  function init(section) {
    var form = section.querySelector('.fs-order__form');
    if (!form || form.dataset.fsWired === '1') return;
    form.dataset.fsWired = '1';

    var radios = Array.prototype.slice.call(
      form.querySelectorAll('.fs-order__choice-input')
    );
    if (!radios.length) return;

    var heading = section.querySelector('[data-fs-heading]');
    var submit = form.querySelector('[data-fs-submit]');
    /* The notes live outside the form, in the left column */
    var groups = Array.prototype.slice.call(
      section.querySelectorAll('[data-fs-for]')
    );

    function apply(type) {
      section.setAttribute('data-fs-enquiry', type);

      groups.forEach(function (el) {
        var list = (el.getAttribute('data-fs-for') || '').split(/\s+/);
        var on = list.indexOf(type) !== -1;
        el.hidden = !on;

        Array.prototype.forEach.call(
          el.querySelectorAll('input, select, textarea'),
          function (control) {
            control.disabled = !on;
            if (control.hasAttribute('data-fs-required')) {
              if (on) control.setAttribute('required', '');
              else control.removeAttribute('required');
            }
          }
        );
      });

      if (heading) {
        var h = heading.getAttribute('data-heading-' + type);
        if (h) heading.textContent = h;
      }
      if (submit) {
        var l = submit.getAttribute('data-label-' + type);
        if (l) submit.textContent = l;
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) apply(r.getAttribute('data-fs-type'));
      });
    });

    initMulti(section);

    /* Deep links carry the answer: /pages/order?type=wedding */
    var wanted = null;
    try {
      wanted = new URLSearchParams(window.location.search).get('type');
    } catch (e) { /* older browser — fall through to the default */ }
    if (wanted) wanted = wanted.toLowerCase();

    var start = radios.filter(function (r) { return r.checked; })[0];
    if (wanted && TYPES.indexOf(wanted) !== -1) {
      var match = radios.filter(function (r) {
        return r.getAttribute('data-fs-type') === wanted;
      })[0];
      if (match) { match.checked = true; start = match; }
    }

    apply(start ? start.getAttribute('data-fs-type') : TYPES[0]);
  }

  /* The store's timezone can be a day off the customer's, so "at least 24
     hours' notice" is re-derived locally. */
  function minTomorrow(scope) {
    var t = new Date();
    t.setDate(t.getDate() + 1);
    var iso = t.getFullYear() + '-' +
      String(t.getMonth() + 1).padStart(2, '0') + '-' +
      String(t.getDate()).padStart(2, '0');
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-fs-min-tomorrow]'),
      function (input) {
        if (!input.min || iso > input.min) input.min = iso;
      }
    );
  }

  function boot(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('.fs-order'),
      function (section) { init(section); minTomorrow(section); }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* The theme editor re-renders a section in place */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
